/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Share_Code_LabelInputs */



/**
* | output |
* | --- |
* | "Project Share Code" |
*
* @param {Team_Project_Import_Share_Code_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_share_code_label = /** @type {((inputs?: Team_Project_Import_Share_Code_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Share_Code_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Code de partage du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt-Freigabecode")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codice di condivisione del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Код доступа к проекту")
	if (locale === "es") return /** @type {LocalizedString} */ ("Código para compartir del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目共享代码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクト共有コード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट शेयर कोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Código de compartilhamento do projeto")
	return /** @type {LocalizedString} */ ("Project Share Code")
});